<!-- search Public organization -->
<template>
  <div id="search" class="search">
    <transition name="slide-up">
      <div class="search-inner" v-show="show">
        <div class="searchHeader">
          <div class="searchHeader_view1">
            <div class="text">{{ viewTitle }}</div>
            <div class="icon"><img src="../../assets/images/ShutDown.svg" @click="closeView" /></div>
          </div>
          <div class="searchHeader_view2" v-if="viewName !== 'network'">
            <input ref="input_focus" type="text" :placeholder="$t('nav.search_components_placeHolder')" v-model="searchText" @keyup="searchTextInput" />
            <div class="searchIcon">
              <img src="@/assets/images/searchIcon1.svg" />
            </div>
          </div>
        </div>
        <div class="search_core" ref="search_core">
          <!-- 国家和法币  -->
          <lazy-component>
            <ul v-if="viewName === 'payCurrency' || viewName === 'payCurrency-sell'">
              <template v-for="(item, index) in computed_countries_list">
                <div class="screen_title" v-if="item.title">{{ $t(item.title) }}</div>
                <li
                  class="payCurrencyLi "
                  v-for="(ite, ind) in item.list"
                  :key="item.title + ind"
                  @click="choiseCountriesItem(ite)"
                  :class="{
                    ac:
                      (viewName === 'payCurrency' && fiatCurrencyInfo.alpha2 == ite.alpha2 && fiatCurrencyInfo.fiat == ite.fiat && fiatCurrencyInfo.fiatSymbol == ite.symbol) ||
                      (viewName == 'payCurrency-sell' && $store.state.feeParams.fiatCode == ite.fiat && $store.state.feeParams.alpha2 == ite.alpha2)
                  }"
                >
                  <div class="seach_li_text">
                    <img class="flag" :src="ite.flag" v-lazy="ite.flag" />
                    <div class="col2">
                      <span v-if="viewName === 'payCurrency'" class="abbreviationName"> {{ ite.fiatName }}</span>
                      <span v-else-if="viewName == 'payCurrency-sell'" class="abbreviationName"> {{ ite.enCommonName }}</span>
                      <span class="allName">{{ ite.fiat }} </span>
                    </div>
                    <img src="@/assets/images/arrow-right1.svg" alt="" class="arrow" />
                  </div>
                </li>
              </template>
            </ul>
          </lazy-component>

          <!---------------------------- 买币选择加密货币 ---------------------------->
          <Crypto-list v-if="viewName === 'currency'" :viewName="viewName" :searchText="searchText" ref="CryptoList_ref" />

          <!-- 网络 -->
          <ul v-if="viewName === 'network'">
            <li v-for="(item, index) in basicData" :key="'basicData' + index" @click="choiseItem('network', item)">
              <!-- {{ item.network }} -->
              <p class="seach_li_text">
                <span class="seach_li_allText">{{ item.networkName }}</span>
              </p>
              <p class="seach_li_rightIcon"><img src="../../assets/images/rightIcon.png" /></p>
            </li>
          </ul>

          <!-- 卖币加密货币 -->
          <lazy-component>
            <ul v-if="viewName === 'currency-sell'">
              <div v-if="searchText === ''">
                <div class="screen_title">{{ $t('nav.search_components_All') }}</div>
                <li
                  :class="{ allCurrencyLi: index === 0, ac: viewName === 'currency-sell' && $store.state.sellRouterParams.currencyData.sellNetwork.coin == item.sellNetwork.coin && $store.state.sellRouterParams.currencyData.sellNetwork.network == item.sellNetwork.network }"
                  v-for="(item, index) in cryptoCurrencyVOList"
                  :key="'cryptoCurrencyVOList' + index"
                  @click="choiseItem('currency-sell', item)"
                >
                  <div class="seach_li_text ">
                    <img class="flag" :src="item.logoUrl" v-lazy="item.logoUrl" />
                    <div class="col2">
                      <div class="abbreviationName">{{ item.name }}</div>
                      <span class="seach_li_allText allName" v-if="item.sellNetwork">{{ item.sellNetwork.networkName }}</span>
                    </div>
                    <img src="@/assets/images/arrow-right1.svg" alt="" class="arrow" />
                  </div>
                </li>
              </div>
              <div v-else>
                <li
                  v-for="(item, index) in searchData"
                  :key="'search_' + index"
                  @click="choiseItem('currency-sell', item)"
                  :class="{ ac: viewName === 'currency-sell' && $store.state.sellRouterParams.currencyData.sellNetwork.coin == item.sellNetwork.coin && $store.state.sellRouterParams.currencyData.sellNetwork.network == item.sellNetwork.network }"
                >
                  <div class="seach_li_text ">
                    <img class="flag" :src="item.logoUrl" v-lazy="item.logoUrl" />
                    <div class="col2">
                      <div class="abbreviationName">{{ item.name }}</div>
                      <span class="seach_li_allText allName" v-if="item.sellNetwork">{{ item.sellNetwork.networkName }}</span>
                    </div>
                    <img src="@/assets/images/arrow-right1.svg" alt="" class="arrow" />
                  </div>
                </li>
              </div>
            </ul>
          </lazy-component>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { debounce } from '@/utils';
import Vue from 'vue';
import { mapState } from 'vuex';

/**
 * 搜索、选择列表组件
 * viewName - 组件名称
 * allBasicData - 买卖币基本数据
 */

export default {
  name: 'search',
  components: {
    CryptoList: () => import('@/components/SearchView/childrens/CryptoList')
  },
  props: ['viewName', 'allBasicData', 'choiseItemData', 'routerFrom'],
  data() {
    return {
      show: false,
      viewTitle: '',

      //Search for data
      searchText: '',

      //all data(all / network)
      basicData: {},

      //国家法币上次交易数据
      recent_payCurrency: [],

      cryptoCurrency_recentList: [],
      //Recommended digital currency list
      popularList: [],
      //Support digital currency list
      cryptoCurrencyVOList: [],

      //国家法币
      countryLegalCurrency: [],

      countriesList: {
        recent_obj: {
          title: 'search_components.recent',
          list: []
        },
        all_obj: {
          title: 'search_components.availableNow',
          list: []
        },
        search_obj: {
          title: '',
          list: []
        }
      }
    };
  },
  computed: {
    //Fuzzy search
    // eslint-disable-next-line vue/return-in-computed-property
    searchData() {
      if (this.searchText && this.viewName === 'currency-sell') {
        let resultArray1 = [],
          resultArray2 = [],
          resultArray3 = [],
          resultArray4 = [],
          all_resultArray = [];
        //Match full name
        resultArray1 = this.cryptoCurrencyVOList.filter((value, index) => {
          if (value.fullName.includes(this.searchText)) {
            this.cryptoCurrencyVOList[index].indexOfNum = value.fullName.indexOf(this.searchText);
            return value;
          }
        });
        //Match full name - Initial to capital
        resultArray2 = this.cryptoCurrencyVOList.filter((value, index) => {
          if (value.fullName.includes(this.searchText.replace(/^\S/, s => s['toUpperCase']()))) {
            this.cryptoCurrencyVOList[index].indexOfNum = value.fullName.indexOf(this.searchText.replace(/^\S/, s => s['toUpperCase']()));
            return value;
          }
        });
        //Matching abbreviations - Capitalize
        resultArray3 = this.cryptoCurrencyVOList.filter((value, index) => {
          if (value.name.includes(this.searchText.toUpperCase())) {
            this.cryptoCurrencyVOList[index].indexOfNum = value.name.indexOf(this.searchText.toUpperCase());
            return value;
          }
        });
        //Matching abbreviations
        resultArray4 = this.cryptoCurrencyVOList.filter((value, index) => {
          if (value.name.includes(this.searchText)) {
            this.cryptoCurrencyVOList[index].indexOfNum = value.name.indexOf(this.searchText);
            return value;
          }
        });
        all_resultArray = all_resultArray
          .concat(resultArray1)
          .concat(resultArray2)
          .concat(resultArray3)
          .concat(resultArray4);
        all_resultArray = [...new Set(all_resultArray)];
        all_resultArray.sort((a, b) => {
          return a.indexOfNum - b.indexOfNum;
        });
        return all_resultArray;
      }
    },
    computed_countries_list() {
      let arr = [];
      if (this.searchText === '') {
        arr = [this.countriesList.all_obj];

        if (this.countriesList.recent_obj.list.length > 0) {
          arr.unshift(this.countriesList.recent_obj);
        }
      } else {
        arr = [this.countriesList.search_obj];
      }
      return arr;
    },
    ...mapState('faitBuyPage', {
      fiatCurrencyInfo: state => state.fiatCurrencyInfo
    })
  },
  watch: {
    allBasicData: {
      immediate: true,
      deep: true,
      handler() {
        this.initializationData();
      }
    },
    searchText(val) {
      if (this.viewName === 'payCurrency' || this.viewName === 'payCurrency-sell') {
        this.getWorldFiatList();
      }
    },
    computed_countries_list() {
      this.$nextTick(() => {
        let removeClassName = () => {
          let dom_lis = this.$refs.search_core.querySelectorAll('li.ac');
          if (dom_lis.length > 1) {
            dom_lis.forEach((item, index) => {
              if (index > 0) {
                item.classList.remove('ac');
              }
            });
          }
        };
        setTimeout(removeClassName, 5);
        setTimeout(removeClassName, 30);
        setTimeout(removeClassName, 100);
        setTimeout(removeClassName, 300);
      });
    }
  },
  mounted() {
    this.show = true;
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.input_focus.focus();
      }, 300);
    });
    this.customComponentTitle();

    if (['payCurrency', 'payCurrency-sell'].includes(this.viewName)) {
      // 请求国家数据;
      this.getWorldFiatList();
    }
  },
  methods: {
    getWorldFiatList() {
      let params = {
        pageIndex: 1,
        pageSize: 999,
        side: 'buy', // 'sell'
        name: this.searchText
      };
      if (this.viewName === 'payCurrency') {
        params.side = 'buy';
      } else if (this.viewName === 'payCurrency-sell') {
        params.side = 'sell';
      }

      this.$axios
        .get(this.$api.get_worldFiatList, params, '')
        .then(res => {
          if (res && res.data) {
            let countriesList = {
              recent_obj: {
                title: 'search_components.recent',
                list: []
              },
              all_obj: {
                title: 'search_components.availableNow',
                list: []
              },
              search_obj: {
                title: '',
                list: []
              }
            };
            if (this.viewName === 'payCurrency') {
              countriesList.recent_obj.list = res.data.buyRecentFiatList;
            } else if (this.viewName === 'payCurrency-sell') {
              countriesList.recent_obj.list = res.data.sellRecentFiatList;
            }
            countriesList.all_obj.list = res.data.pageData.result;
            countriesList.search_obj.list = res.data.pageData.result;
            this.countriesList = countriesList;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    //Judge title name
    customComponentTitle() {
      if (this.viewName === 'payCurrency') {
        this.viewTitle = this.$t('nav.search_components_currencyTitle');
        return;
      }
      if (this.viewName === 'payCurrency-sell') {
        this.viewTitle = this.$t('nav.search_components_countryTitle');
        return;
      }
      if (this.viewName === 'currency' || this.viewName === 'currency-sell') {
        this.viewTitle = this.$t('nav.search_components_cryptoTitle');
        return;
      }
      if (this.viewName === 'network') {
        this.viewTitle = this.$t('nav.search_components_networkTitle');
        return;
      }
    },

    //Get and call component path, processing data
    initializationData() {
      if (this.viewName === 'network') {
        this.basicData = [];
        this.basicData = JSON.parse(JSON.stringify(this.allBasicData));
        return;
      }
      if (this.viewName === 'payCurrency') {
        this.basicData = [];
        this.recent_payCurrency = [];
        let newWorldList = [];
        let recent_newWorldList = [];

        if (this.allBasicData.worldList) {
          this.allBasicData.worldList.forEach(item => {
            if (item.buyFiatList) {
              item.buyFiatList.forEach(item2 => {
                let fiat = {
                  code: item2.code
                };
                fiat = { ...fiat, ...item };
                newWorldList.push(fiat);
              });
            }
          });
          newWorldList = newWorldList.filter(item => {
            return item.buyEnable === 1;
          });
        }
        if (this.allBasicData.buyRecentWorldList) {
          this.allBasicData.buyRecentWorldList.forEach(item => {
            if (item.buyFiatList) {
              item.buyFiatList.forEach(item2 => {
                let fiat = {
                  code: item2.code
                };
                fiat = { ...fiat, ...item };
                recent_newWorldList.push(fiat);
              });
            }
          });
          recent_newWorldList = recent_newWorldList.filter(item => {
            return item.buyEnable === 1;
          });
        }

        this.recent_payCurrency = recent_newWorldList;
        this.basicData = newWorldList;
        return;
      }
      if (this.viewName === 'payCurrency-sell') {
        let allBasicData = JSON.parse(JSON.stringify(this.allBasicData));
        this.basicData = [];
        this.recent_payCurrency = [];
        let newWorldList = [];
        let recent_newWorldList = [];
        if (allBasicData.worldList) {
          allBasicData.worldList.forEach(item => {
            if (item.sellFiatList) {
              item.sellFiatList.forEach(item2 => {
                let fiat = {
                  code: item2.code
                };
                fiat = { ...fiat, ...item };
                newWorldList.push(fiat);
              });
            }
          });
          newWorldList = newWorldList.filter(item => {
            return item.sellEnable === 1;
          });
        }
        this.basicData = newWorldList;
        //上次购买过的国家和法币
        if (allBasicData.sellRecentWorldList) {
          allBasicData.sellRecentWorldList.forEach(item => {
            if (item.sellFiatList) {
              item.sellFiatList.forEach(item2 => {
                let fiat = {
                  code: item2.code
                };
                fiat = { ...fiat, ...item };
                recent_newWorldList.push(fiat);
              });
            }
          });
          recent_newWorldList = recent_newWorldList.filter(item => {
            return item.buyEnable === 1;
          });
        }
        this.recent_payCurrency = recent_newWorldList;
        return;
      }
      if (this.viewName === 'currency-sell') {
        this.basicData = JSON.parse(JSON.stringify(this.allBasicData));
        if (this.basicData.cryptoCurrencyResponse) {
          let newCurrencyList = [];
          let newCurrencyList_network = [];
          newCurrencyList = this.basicData.cryptoCurrencyResponse.cryptoCurrencyList.filter(item => {
            return item.isSell === 1;
          });
          //全部
          newCurrencyList.forEach(item => {
            if (item.sellNetworkList) {
              item.sellNetworkList.forEach(item2 => {
                let fiat = {
                  sellNetwork: item2
                };
                fiat = { ...fiat, ...item };
                newCurrencyList_network.push(fiat);
              });
            }
          });
          this.cryptoCurrencyVOList = newCurrencyList_network;
        }
        return;
      }
    },

    //close component
    closeView() {
      this.show = false;
      setTimeout(() => {
        if (this.viewName === 'currency' || this.viewName === 'currency-sell' || this.viewName === 'payCurrency-sell' || this.viewName === 'payCurrency') {
          this.$parent.searchState = true;
          return;
        }
        if (this.viewName === 'network') {
          this.$parent.$parent.$refs.viewTab.tabState = true;
          this.$parent.searchViewState = false;
          return;
        }
        if (this.$route.path === '/sell-formUserInfo') {
          this.$parent.$parent.$refs.viewTab.changeCountry_state = false;
          this.$parent.changeCountry_state = false;
        }
      }, 300);
    },

    searchTextInput: debounce(function() {
      //买币加密币数据
      if (this.viewName === 'currency') {
        try {
          this.$refs.CryptoList_ref && this.$refs.CryptoList_ref.queryCryptoList('search');
        } catch (e) {
          console.log(e);
        }
      }
    }, 500),

    choiseCountriesItem(item) {
      if (this.viewName === 'payCurrency') {
        this.$parent.$refs.buyCrypto_ref.modifyInfo(1, item);
      } else if (this.viewName === 'payCurrency-sell') {
        //卖币
        this.$parent.$refs.sellCrypto_ref.handlePayWayList(item, 2, item.fiat);
        this.$parent.$refs.sellCrypto_ref.amountControl();
      }
      this.$parent.searchState = true;
    },

    //Select data
    choiseItem(type, item) {
      setTimeout(() => {
        if (type === 'network') {
          this.$nextTick(() => {
            this.$parent.selectNetwork(item);
            this.$parent.$parent.$refs.viewTab.tabState = true;
            this.$parent.searchViewState = false;
          });
          return;
        }
        if (this.viewName === 'currency-sell') {
          //卖币
          let currencyData = {
            icon: item.logoUrl,
            name: item.name,
            maxSell: item.sellNetwork.maxSell,
            minSell: item.sellNetwork.minSell,
            cryptoCurrencyNetworkId: item.cryptoCurrencyNetworkId,
            symbol: item.symbol,
            sellNetwork: item.sellNetwork
          };
          this.$parent.$refs.sellCrypto_ref.currencyData = currencyData;
          this.$store.state.sellRouterParams.currencyData = currencyData;
          this.$store.state.sellRouterParams.cryptoCurrency = item.name;
          this.$store.state.feeParams.symbol = item.symbol;
          this.$store.state.feeParams_order.symbol = item.symbol;
          this.$parent.$refs.sellCrypto_ref.amountControl();
          this.$parent.searchState = true;
          return;
        }
      });
    }
  }
};
</script>

<style lang="scss" src="./index.scss" scoped></style>
